import { render } from "./MetaPolicyView.vue?vue&type=template&id=cf330326&scoped=true"
import script from "./MetaPolicyView.vue?vue&type=script&lang=js"
export * from "./MetaPolicyView.vue?vue&type=script&lang=js"

import "./MetaPolicyView.vue?vue&type=style&index=0&id=cf330326&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf330326"]])

export default __exports__